<template>
  <v-container grid-list-xl>
    <v-layout row wrap> 
        <v-data-table style="margin-top: 30px;width: 100% !important;" :headers="headers" :items="storeAudits" hide-actions disable-initial-sort class="elevation-1">
          <template slot="items" slot-scope="props">
            <tr class="sortableRow" id="rows">
              <td width="40%">{{ props.item.prev_name }}</td>
              <td width="40%">{{ props.item.new_name }}</td>
              <td width="20%">{{ props.item.timsetamp }}</td>
            </tr>
          </template>
        </v-data-table>
        <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder" style="margin-top: 0px !important;">
          <div style="float: right">
            <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
          </div>
        </div>
    </v-layout>
  </v-container>
</template>

<script>
	import { mapGetters } from 'vuex';

	export default {
	  name: 'Settings',
	  data () {
			return {
			  search: '',
			  emails: '',
    headers: [
        { text: 'Previous Store', value: 'name', width: '40%' },
        { text: 'New Store', value: 'description', width: '40%' },
        { text: 'Audit Date', value: 'created_on', width: '20%' }
      ]
			};
		},
		methods: {
      fncHideModal() {
        this.$store.commit('hideModal');
      }
		},
    mounted() {
	    this.$store.dispatch('fncGetStoreAudits', this.globalModalParams.quote.id )
    },
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
        'storeAudits'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
